export const _noOpProvider = {
    initialize: ()=>{},
    handleAction: (action, data)=>{},
    handleLocationChange: (location)=>{},
    setContext: (context)=>{},
    setUser: (user)=>{},
    setServiceLine: (serviceLine)=>{},
    trackView: (viewName)=>{},
    trackAction: (action, data)=>{},
    reset: ()=>{}
};
